import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Img } from 'react-image';

import { Theme } from 'ui_system/theme';
import BackIcn from 'views/ui/icons/back-icon';
import LocationIcn from 'views/ui/icons/location-icon';
import ComputerIcn from 'views/ui/icons/computer';

export const rowStyle = css`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 5px;
  padding-right: 5px;

  i {
    color: ${Theme.colors.lightText};
  }
`;

export const hideMobile = css`
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    display: none;
  }
`;

export const hideDesktop = css`
  @media (min-width: ${Theme.mobile.phoneWidth}px) {
    display: none;
  }
`;

export const iconStyle = css`
  i {
    color: ${Theme.colors.lightText};
  }
  i.af-angle-right {
    font-size: 30px;
    height: 32px;
  }
`;

export const Text = styled('span')`
  justify-content: ${(props) => (props.center ? 'center' : 'flex-start')};
  font-weight: ${(props) => (props.bold ? '600' : '400')};
  color: ${(props) => (props.color ? props.color : Theme.colors.black)};
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : 'inherit')};

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: ${(props) =>
      props.mobileFontsize ? `${props.mobileFontsize}px` : 'inherit'};
  }

  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : '0px'};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : '0px'};
  margin-left: ${(props) =>
    props.marginLeft ? `${props.marginLeft}px` : '0px'};

  &:hover {
    cursor: ${(props) => (props.hover ? 'pointer' : 'default')};
  }
`;

export const Empty = styled('div')`
  text-align: center;
  padding-top: 50px;
  color: ${Theme.colors.lightText};
`;

export const Section = styled('div')`
  grid-area: ${(props) => props.gridArea};
`;

export const DateSection = styled(Section)`
  ${rowStyle};
  height: 100%;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding-left: 0px;
    padding-right: 0px;
  }
`;
export const PictureSection = styled(Section)`
  ${rowStyle};
  height: 90px;
  padding-left: 0px;
  padding-right: 0px;
`;

export const Image = styled(Img)`
  height: 100%;
  width: 100%;
`;

export const NameSection = styled(Section)`
  padding: 14px;
  padding-left: 10px;
  height: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
`;
export const GuestsSection = styled(Section)`
  ${rowStyle};
  ${(props) => (props.hideMobile ? hideMobile : '')}
  ${(props) => (props.hideDesktop ? hideDesktop : '')}

  color: ${Theme.colors.black};
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    position: absolute;
    bottom: 13px;
    height: unset;
    padding: 0;
    i {
      top: 2px;
    }
  }
`;
export const ArrowSection = styled(Section)`
  ${rowStyle};
  ${hideMobile};
  ${iconStyle};
`;

export const List = styled('div')``;

export const Row = styled('div')`
  display: grid;
  grid-template-columns: 100px 62px 4fr 1fr 0.7fr;
  grid-template-rows: 90px;
  grid-template-areas: 'date picture name guests arrow';

  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${Theme.colors.lightLine};

  cursor: pointer;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    grid-template-areas: 'date picture name';
    grid-template-columns: 75px 62px 1fr;
  }
`;

// Back links styling
export const BackAction = styled('div')`
  display: flex;
  align-items: center;
  padding: 15px;
  color: ${(props) => props.color};
  border-bottom: 1px solid ${Theme.colors.lightLine};
`;

export const BackIcon = styled(BackIcn)`
  color: ${(props) => props.color};
  fill: ${(props) => props.color};
  margin-right: 10px;
  height: 18px;
  width: 18px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    width: 18px;
    height: 18px;
    margin-right: 7px;
  }
`;

// Horizontal line / divider (short version)
export const HR = styled('div')`
  height: 1px;
  width: 100px;
  background: ${Theme.colors.lightLine};
  margin-bottom: 15px;
`;

// Icon + location text styling
export const LocationSection = styled('div')`
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* overflow: hidden; */
  position: relative;
  margin-top: 3px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    margin-top: 0px;
  }
`;

export const LocationIcon = styled(LocationIcn)`
  width: 12px;
  fill: ${Theme.colors.lightText};
  position: absolute;
  top: 0;
  left: 0;
`;

export const ComputerIcon = styled(ComputerIcn)`
  width: 16px;
  margin-left: 1px;
  fill: ${Theme.colors.lightText};
  position: absolute;
  top: 2px;
  left: 0;
`;
